module.exports = __webpack_public_path__ + "img/w63b.db04d36a.jpg";